'use client'

import Image from 'next/image'

import { cn } from '@/lib/utils'

import { EASE, Eyebrow, QuietLink, useReveal } from '@/components/page-kit'
import { LMS } from './data'

/* The authored quote with the customer's own mark — nmims.jpg really is SVKM's
   NMIMS, so the pairing states nothing untrue.

   No photograph on this page: the largest LMS asset is lms2.jpg at 945×534,
   too small to hold a full-bleed band. Type carries the page instead. */

export function LmsProof() {
  const block = useReveal<HTMLDivElement>(0.15)

  return (
    <section className="pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <div ref={block.ref} className="max-w-4xl">
          <Eyebrow>Proof</Eyebrow>

          <blockquote
            className="mt-6"
            style={{
              opacity: block.shown ? 1 : 0,
              transform: block.shown ? 'none' : 'translateY(12px)',
              transition: `opacity 700ms ${EASE} 60ms, transform 700ms ${EASE} 60ms`,
            }}
          >
            <p className="font-heading text-2xl font-normal leading-[1.3] tracking-tight text-foreground sm:text-3xl lg:text-[36px] lg:leading-[1.28]">
              &ldquo;{LMS.quote.text}&rdquo;
            </p>

            <footer className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-4">
              <div className="relative h-9 w-28 shrink-0 sm:h-10 sm:w-36">
                <Image
                  src="/stories/nmims.webp"
                  alt="SVKM's NMIMS"
                  fill
                  sizes="144px"
                  className={cn(
                    'object-contain object-left',
                    // Single-ink treatment, matching the homepage logo rail.
                    'opacity-90 mix-blend-multiply grayscale',
                    'dark:opacity-100 dark:mix-blend-screen dark:grayscale dark:invert'
                  )}
                />
              </div>

              <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <cite className="text-sm font-medium not-italic text-foreground">
                  {LMS.quote.author}
                </cite>
                <span className="text-sm text-muted-foreground">
                  {LMS.quote.role}
                </span>
              </div>
            </footer>
          </blockquote>

          <div
            className="mt-8"
            style={{
              opacity: block.shown ? 1 : 0,
              transition: `opacity 700ms ${EASE} 260ms`,
            }}
          >
            <QuietLink href="/customer-stories">Read the full story</QuietLink>
          </div>
        </div>
      </div>
    </section>
  )
}
